export const LOAD_FILE = "LOAD_FILE";
export const LOAD_FILE_TANK = "LOAD_FILE_TANK";
export const LOAD_FILE_FUEL_FILTER = "LOAD_FILE_FUEL_FILTER";
export const LOAD_FILE_AIR_SYSTEM = "LOAD_FILE_AIR_SYSTEM";
export const LOAD_FILE_START_MOTOR = "LOAD_FILE_START_MOTOR";
export const LOAD_FILE_BOARD_FAILURES = "LOAD_FILE_BOARD_FAILURES";
export const LOAD_FILE_AC = "LOAD_FILE_AC";
export const CLEAN_IMAGES = "CLEAN_IMAGES";
